(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CpApiLogSendSabreEmail',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#cpapilogsendsabreemail-email_template').on('change', function change(e) {
			window.location.href = Adzuki.base_uri + '/CpApiLog/sendSabreEmail/0/' + $(this).val();
		});
	};

}(jQuery, window.Adzuki || {}));
